export default {
  zh: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ruleDetail:`1. Users can send messages to broadcast in broadcast and world chat, and click on the message to go to the corresponding room.<br/>
    2. Messages with duration will be displayed first. If no new duration is obtained within three days after the pinned time expires, the message will be deleted on broadcast.<br/>
    <br/>
    Time increase rules:<br/>
    Send broadcast: 500 gold coins, stay on top for 10 minutes<br/>
    Gift 1: 500 gold coins plus 10 minutes<br/>
    Gift 2: 1000 gold coins plus 50 minutes<br/>
    Gift 3: 2000 gold coins 100 minutes`,
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
    rule: 'القواعد',
    timeR: 'العد التنازلي',
    days: 'أيام',
    ruleDetail:`1. يمكن للمستخدمين إرسال رسائل  البرودكاست الى الدردشة العالمية، يمكن النقر على الرسالة للانتقال إلى غرفة المرسل.<br/>
    2. سيتم عرض الرسائل ذات المدة أولاً. إذا لم يتم الحصول على مدة جديدة خلال ثلاثة أيام بعد انتهاء الوقت المثبت، فسيتم حذف الرسالة عند البث.<br/>
    <br/>
    قواعد زيادة الوقت:<br/>
    الوقت الاصلي: 500 قطعة ذهبية، الضهور في القمة لمدة 10 دقائق<br/>
    الهدية الأولى:  إضافة  10 دقائق لكل هدية بقيمة 500 كوينز<br/>
    الهدية الثانية:  إضافة  50 دقائق لكل هدية بقيمة 1000 كوينز<br/>
    الهدية الثانية:  إضافة  100 دقائق لكل هدية بقيمة 2000 كوينز`,
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ruleDetail:`1. Users can send messages to broadcast in broadcast and world chat, and click on the message to go to the corresponding room.<br/>
    2. Messages with duration will be displayed first. If no new duration is obtained within three days after the pinned time expires, the message will be deleted on broadcast.<br/>
    <br/>
    Time increase rules:<br/>
    Send broadcast: 500 gold coins, stay on top for 10 minutes<br/>
    Gift 1: 500 gold coins plus 10 minutes<br/>
    Gift 2: 1000 gold coins plus 50 minutes<br/>
    Gift 3: 2000 gold coins 100 minutes`,
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    rule: 'Kural',
    timeR: 'Kalan süre: ',
    days: 'gün',
    ruleDetail:`1. Kullanıcılar yayın ve dünya sohbetinde yayınlanmak üzere mesaj gönderebilir ve mesaja tıklayarak ilgili odaya gidebilirler.<br/>
    2. Önce süresi olan mesajlar görüntülenecektir. Sabitlenen sürenin bitiminden sonraki üç gün içinde yeni süre elde edilememesi halinde mesaj yayında silinecektir.<br/>
    <br/>
    Süre artış kuralları:<br/>
    Yayın gönder: 500 altın, 10 dakika zirvede kal<br/>
    Hediye 1: 500 altın artı 10 dakika<br/>
    Hediye 2: 1000 altın artı 50 dakika<br/>
    Hediye 3: 2000 altın artı 100 dakika`,
  },
  pt:{
    topLovers: "Top Amantes",
    treeOfLovers: "Árvore dos Amantes",
    rule: 'Regras',
    timeR: 'Contagem regressiva: ',
    days: 'dias',
    ruleDetail: `1. Os usuários podem enviar mensagens para a transmissão e no chat mundial, e clicar na mensagem para ir para a sala correspondente.<br/>
    2. As mensagens com duração serão exibidas primeiro. Se nenhuma nova duração for obtida dentro de três dias após o tempo fixado expirar, a mensagem será excluída da transmissão.<br/>
    <br/>
    Regras de aumento de tempo:<br/>
    Enviar para a transmissão: 500 moedas de ouro, permaneça no topo por 10 minutos<br/>
    Presente 1: 500 moedas de ouro mais 10 minutos<br/>
    Presente 2: 1000 moedas de ouro mais 50 minutos<br/>
    Presente 3: 2000 moedas de ouro mais 100 minutos`,

  },
  id:{
    topLovers: "Pecinta Teratas",
    treeOfLovers: "Pohon Pecinta",
    rule: 'Aturan',
    timeR: 'Hitung mundur: ',
    days: 'hari',
    ruleDetail: `1. Pengguna dapat mengirim pesan untuk disiarkan di siaran dan obrolan dunia, dan klik pada pesan untuk menuju ke ruangan yang sesuai.<br/>
    2. Pesan dengan durasi akan ditampilkan terlebih dahulu. Jika tidak ada durasi baru yang diperoleh dalam tiga hari setelah waktu yang ditandai habis, pesan akan dihapus dari siaran.<br/>
    <br/>
    Aturan penambahan waktu:<br/>
    Kirim siaran: 500 koin emas, bertahan di atas selama 10 menit<br/>
    Hadiah 1: 500 koin emas tambah 10 menit<br/>
    Hadiah 2: 1000 koin emas tambah 50 menit<br/>
    Hadiah 3: 2000 koin emas 100 menit`,

  },
  uz:{
    topLovers: "Eng Yaxshi Sevuvchilar",
    treeOfLovers: "Sevuvchilar Daraxti",
    rule: 'Qoidalar',
    timeR: 'Sanog\'i:',
    days: 'kunlar',
    ruleDetail: `1. Foydalanuvchilar translyatsiya va dunyo chatida xabar yuborishi va xabarni bosingan holda tegishli xonaga o'tishlari mumkin.<br/>
    2. Davomiylikka ega xabarlar birinchi bo'lib ko'rsatiladi. Agar pinli vaqt tugaganidan keyin uch kun davomida yangi davomiylik olinmasa, xabar translyatsiyadan o'chiriladi.<br/>
    <br/>
    Vaqtni oshirish qoidalari:<br/>
    Translyatsiya yuborish: 500 oltin tanga, 10 daqiqa yuqorida qoladi<br/>
    Sovg'a 1: 500 oltin tanga, yana 10 daqiqa qo'shiladi<br/>
    Sovg'a 2: 1000 oltin tanga, yana 50 daqiqa qo'shiladi<br/>
    Sovg'a 3: 2000 oltin tanga, yana 100 daqiqa qo'shiladi`
},
    ru:{
    topLovers: "Топ Любовников",
    treeOfLovers: "Дерево Любовников",
    rule: 'Правила',
    timeR: 'Обратный отсчет: ',
    days: 'дней',
    ruleDetail: `1. Пользователи могут отправлять сообщения в трансляции и мировом чате, а затем нажимать на сообщение, чтобы перейти в соответствующую комнату.<br/>
    2. Сообщения с длительностью будут отображаться первыми. Если в течение трех дней после истечения времени закрепления не поступит новое время, сообщение будет удалено из трансляции.<br/>
    <br/>
    Правила увеличения времени:<br/>
    Отправить трансляцию: 500 золотых монет, оставаться наверху в течение 10 минут<br/>
    Подарок 1: 500 золотых монет плюс 10 минут<br/>
    Подарок 2: 1000 золотых монет плюс 50 минут<br/>
    Подарок 3: 2000 золотых монет 100 минут`
},
    fa:{
    topLovers: "برترین عاشقان",
    treeOfLovers: "درخت عاشقان",
    rule: 'قوانین',
    timeR: 'شمارش معکوس: ',
    days: 'روزها',
    ruleDetail: `1. کاربران می‌توانند پیام‌هایی به پخش زنده و چت جهانی ارسال کنند و روی پیام کلیک کرده و به اتاق مربوطه بروند.<br/>
    2. پیام‌هایی که مدت زمان دارند، ابتدا نمایش داده خواهند شد. اگر پس از پایان زمان ثابت، هیچ مدت زمان جدیدی طی سه روز دریافت نشود، پیام از پخش زنده حذف خواهد شد.<br/>
    <br/>
    قوانین افزایش زمان:<br/>
    ارسال پخش زنده: 500 سکه طلا، 10 دقیقه در بالا می‌ماند<br/>
    هدیه 1: 500 سکه طلا به علاوه 10 دقیقه<br/>
    هدیه 2: 1000 سکه طلا به علاوه 50 دقیقه<br/>
    هدیه 3: 2000 سکه طلا 100 دقیقه`
}



}



// WEBPACK FOOTER //
// src/pages/activity/rulersRoot/lang.js